import { SETUP_ERROR_CODES, SetupErrorCode } from "@platform/shared/errors";
import { copy } from "@platform/ui/styles";
import { Link, useRouteError } from "react-router";
import { isTRPCClientError } from "~/shared/api/core/trpc.utils";
import { AuthCard, AuthHeading, AuthLayout } from "~/shared/components/AuthElements";
import { TopLevelRouteErrorHandler } from "~/shared/components/errors/Error";

export function ParticipantJoinViewErrorHandler() {
  const error = useRouteError();
  const trpcError = isTRPCClientError(error);

  if (trpcError) {
    if (isSetupErrorMessage(error.message)) {
      switch (error.message) {
        case SETUP_ERROR_CODES.INVITE_INVALID:
        case SETUP_ERROR_CODES.INVITE_EXPIRED:
          return (
            <AuthLayout>
              <AuthCard>
                <div className="grid gap-4">
                  <AuthHeading>Invalid Token</AuthHeading>
                  <p className={copy({ variant: "14" })}>
                    Oops! This setup link is no longer valid. If you think this is a mistake, please email us at{" "}
                    <a href="mailto:app@break-line.com">app@break-line.com</a>.
                  </p>
                  <p className={copy({ variant: "14" })}>
                    Already created your account? <Link to="/login">Login</Link>
                  </p>
                </div>
              </AuthCard>
            </AuthLayout>
          );
      }
    }
  }

  return <TopLevelRouteErrorHandler />;
}

function isSetupErrorMessage(errorMessage: string): errorMessage is SetupErrorCode {
  return Object.values(SETUP_ERROR_CODES).includes(errorMessage as SetupErrorCode);
}
